// @flow
import * as React from 'react';
import {
    getAllUpcomingAuctionsUrl,
    getAuctioneerDirectoryUrl,
    getAuctionResultsUrl,
    getTodayUrl,
} from '../../../utils/urls';
import DropDownMenu from '@liveauctioneers/caterwaul-components/lib/DropDownMenu/DropDownMenu';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faFire } from '@fortawesome/pro-regular-svg-icons/faFire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './FindAuctions.module.scss';

type Props = {
    parent: React.Node,
    trackPastAuctionResultsClick: Function,
};

const FindAuctions = (props: Props) => {
    const { parent, trackPastAuctionResultsClick } = props;

    const links = [
        <Link key={0} className={styles.link} route to={getAllUpcomingAuctionsUrl()}>
            <FormattedMessage id="auction_calendar" />
            <FontAwesomeIcon icon={faCalendarAlt} className={styles.calendar} />
        </Link>,
        <Link key={1} className={styles.link} route to="/find-auctions-near-me">
            <FormattedMessage id="auctions_near_me" />
        </Link>,
        <Link key={2} className={styles.link} route to={getTodayUrl()}>
            <FormattedMessage id="trending_auctions" />
            <FontAwesomeIcon icon={faFire} className={styles.calendar} />
        </Link>,
        <Link key={3} className={styles.link} route to={getAuctioneerDirectoryUrl()}>
            <FormattedMessage id="auction_house_directory" />
        </Link>,
        <Link key={4} className={styles.link} onClick={trackPastAuctionResultsClick} route to={getAuctionResultsUrl()}>
            <FormattedMessage id="past_auction_results" />
        </Link>,
    ];

    const title = <FormattedMessage id="find_auctions" />;

    return (
        <DropDownMenu
            dropdownClass={styles.aDropDown}
            links={links}
            parent={parent}
            placement="bottom"
            popoverClass={styles.popup}
            title={title}
            titleClass={styles['auction-title']}
        />
    );
};

export default React.memo<Props>(FindAuctions, isEqual);
